// extracted by css-extract-rspack-plugin
export default {"base":"jZcVez_ko4AIERNK","small":"t4tOe1kljkGOD97Z","medium":"wW4AjypcJcVIVK6J"};